import { Component, Input, OnInit } from '@angular/core';
import { APIService } from '../api.service';

@Component({
  selector: 'app-set-acct-start-date',
  templateUrl: './set-acct-start-date.component.html',
  styleUrls: ['./set-acct-start-date.component.scss']
})
export class SetAcctStartDateComponent implements OnInit {
    selAcct: any = {
      finYearVal: '0',
      minDT: new Date('01-Jan-2020'),
      maxDT: new Date(),
      acctStartDT: new Date(),
    };
    ledgersData = [];
    jarvisData: any = [];
    agencyData: any = [];
    
    
    
    constructor(private apiService: APIService) { }
    
    @Input() setAcctDTModalRef: any;

    ngOnInit(): void {
        var jarvis = this.apiService.getCookie("Jarvis");
    	if (jarvis) {
      		this.jarvisData = JSON.parse(jarvis);
    	}

        let agencyData = this.apiService.getCookie("M");
    	if (agencyData) {
      		this.agencyData = JSON.parse(agencyData);
    	}

        var erpAgnCookie = this.apiService.getCookie("ERP_Agn");
		var erpAgnencyInfo: any = [];
		if (erpAgnCookie) {
			erpAgnencyInfo = JSON.parse(erpAgnCookie);
		}
		
		var ledger = this.apiService.getCookie('Ledger');
		if (ledger) {
			this.ledgersData = JSON.parse(ledger);
			this.selAcct.finYearVal = "0";
			if (this.ledgersData.length > 0) {
				if (erpAgnencyInfo.length > 0) {
					let acctStartDT: any = erpAgnencyInfo[0]?.AccountStartDT ? new Date(erpAgnencyInfo[0].AccountStartDT).customFormat("#DD#-#MMM#-#YY#") : null;
					let currFinYear: any = new Date("01-Apr-" + new Date().getFullYear()).customFormat("#DD#-#MMM#-#YY#");
					this.selAcct.acctStartDT = acctStartDT ? new Date(acctStartDT) : null;
					
                    if (acctStartDT == null) {
                        this.selAcct.finYearVal = "0";
                    }
                    else if (new Date(acctStartDT).toDateString() == new Date(currFinYear).toDateString()) {
						this.selAcct.finYearVal = "1";
					} 
                    else if (new Date(acctStartDT).toDateString() == new Date().toDateString()) {
						this.selAcct.finYearVal = "2";
					}
					else {
						this.selAcct.finYearVal = "3";
					}
				}
			}
		}
    }

    getCurrentFinancialYear(fromDT: any) {
        let fiscalyear = "";
        let today = new Date(fromDT);
        if ((today.getMonth() + 1) < 4) {
            fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
        } else {
            fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
        }
        return fiscalyear
    }

    // changeAcctStartDT() - change account start date
	changeAcctStartDT() {
		if (this.selAcct.finYearVal == 1) {
			this.selAcct.acctStartDT = new Date("01-Apr-" + this.getCurrentFinancialYear(new Date()));
		}
		else if (this.selAcct.finYearVal == 2) {
			this.selAcct.acctStartDT = new Date();
		}
  	}

	// saveAccountStartDate() - save account start date in database
	saveAccountStartDate() {
		if (this.selAcct.finYearVal == 0) {
			this.apiService.successAlert('Please select a valid option for account opening date.');
			return;
		}
		else if (!this.selAcct.acctStartDT) {
			this.apiService.successAlert('Please select a valid date for account opening date.');
			return;
		}
		else if (this.selAcct.acctStartDT > new Date() || this.selAcct.acctStartDT < this.selAcct.minDT) {
			this.apiService.successAlert('Please select a valid date for account opening date.');
			return;
		}


		let obj = [{
			ChangeType: 'ACCTDT',
			GSTLdgrs: '[]',
			Units: '[]', 
			Stores: '[]',
			ItemCategories: '[]',
			PrdJobStages: '[]',
			PrdRejnReasons: '',
			PrdCfg: '[]',
			acctStartDT: new Date(this.selAcct.acctStartDT).customFormat("#DD#-#MMM#-#YY#"),
		}];

		let myParams = [{
			myUserID: this.jarvisData[0].UserID,
			myToken: this.jarvisData[0].WebToken,
			forAgencyID: this.jarvisData[0].AgencyIDs,
			myAgencyIDs: this.jarvisData[0].AgencyIDs,
			myLastSyncDT: null, 
			isWeb: true,
			ForERPAgencyID: this.agencyData[0].ERPAgencyID,
			actionType: 'set',
			moduleID: 6,
			data: JSON.stringify(obj)
		}];

		this.apiService.sendChange(myParams, (res: any) => {
            if (res.error) {
                this.apiService.successAlert(res.message);
            }
            else {
                if (res) {
                    let respData = JSON.parse(res.updatePackage);
                    if (respData.Table && respData.Table.length > 0) {
                        if (respData.Table[0].ErrCode != -1) {
                            this.apiService.successAlert(respData.Table[0].ErrMsg);
                            return;
                        }
                        for (let key in respData) {
                            const arr = respData[key];

                            if (Array.isArray(arr) && arr.length > 0 && arr[0].Tbl) {
                                const tblKey = arr[0]?.Tbl;
                                const value = JSON.stringify(arr); // Store the full object
								if (tblKey) {
									localStorage.setItem(tblKey, value);
								}
                            }
                        }
                        this.apiService.successAlert('Account opening date set.');
                        this.closeModal('success');
                    }
                }
            }
		}, this.failureResp.bind(this));
	}

    //failureResp - failure handler
    failureResp(res: any) {
        if (res.error) {

        }
        else {
        alert(res.message);
        }
    }

    // closeModal() - close the modal and return the result
    closeModal(from: any) {
        this.setAcctDTModalRef.close(from);
    }

}
